import { FC } from "react";
import { BaseProps } from "./text";
import GText from "./GText";
import { css } from "@emotion/react";
import useScrollTrigger from "../../functions/useScrollTrigger";
import gsap, { Back } from "gsap";

interface Props {
  text?: string;
}

const GTextWave: FC<Props & BaseProps> = (props) => {
  const styles = css`
    font-family: inherit;
    text-transform: uppercase;
    margin: 0;
    font-size: inherit;

    & .g_wave-span {
      transform: translateX(-50%) rotate(-10deg);
      display: block;
      float: left;
      left: 50%;
      position: relative;

      & > span {
        transform: skew(-10deg);
        display: block;
        float: left;
        text-shadow: #533d4a 1px 1px, #533d4a 2px 2px, #533d4a 3px 3px,
          #533d4a 4px 4px, #533d4a 5px 5px, #533d4a 6px 6px;
        min-width: 10px;
        min-height: 10px;
        position: relative;
        opacity: 0;
        bottom: -80px;
      }
    }
  `;

  const { ref } = useScrollTrigger(() => {
    const tl = gsap.timeline();
    tl.to(".g_wave-span span", 0.5, {
      opacity: 1,
      bottom: 0,
      ease: Back.easeOut.config(1.7),
      stagger: 0.05,
      delay: 0.2,
    });
  });

  const splitTextIntoSpan = () => {
    return props.text?.split("").map((l, i) => <span key={i}>{l}</span>);
  };

  return (
    <GText {...props}>
      <h1 css={styles} ref={ref}>
        <span className="g_wave-span">{splitTextIntoSpan()}</span>
      </h1>
    </GText>
  );
};

GTextWave.defaultProps = {
  text: "Grooody",
  fontSize: 40,
};

export default GTextWave;

/*
addPropertyControls(TextWave, {
    text: {
        title: "Text",
        type: ControlType.String,
        defaultValue: "Grooody",
    },
    color: {
        title: "Color",
        type: ControlType.Color,
        defaultValue: "#000",
    },
    letterSpacing: {
        title: "Letter",
        type: ControlType.Number,
    },
    fontSize: {
        title: "Font Size",
        type: ControlType.Number,
        defaultValue: 46,
    },
    fontFamily: {
        title: "Font Family",
        type: ControlType.Font,
        defaultValue: "Inter",
    },
})

*/
